import { render, staticRenderFns } from "./BranchEdit.vue?vue&type=template&id=e384a938&scoped=true"
import script from "./BranchEdit.vue?vue&type=script&lang=js"
export * from "./BranchEdit.vue?vue&type=script&lang=js"
import style0 from "./BranchEdit.vue?vue&type=style&index=0&id=e384a938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e384a938",
  null
  
)

export default component.exports